import { anticipate, backInOut, circInOut } from 'motion-utils';
var unsupportedEasingFunctions = {
  anticipate: anticipate,
  backInOut: backInOut,
  circInOut: circInOut
};

function isUnsupportedEase(key) {
  return key in unsupportedEasingFunctions;
}

function replaceStringEasing(transition) {
  if (typeof transition.ease === "string" && isUnsupportedEase(transition.ease)) {
    transition.ease = unsupportedEasingFunctions[transition.ease];
  }
}

export { replaceStringEasing };